export default function () {
    return {
        restrict: 'A', // Only element name can be used for directive definition
        scope: {}, // Define own scope for directive
        controller: 'directiveMoveTopOnFocusCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/moveTopOnFocus.js